import { apiFetch } from "../utils/apiClient";
const source_id = Number(process.env.REACT_APP_SOC_ID || 1);

export const getUnifiedHealthPlans = (data) => {
    
  return async (dispatch) => {
    try {
      const val = await apiFetch(dispatch, `${process.env.REACT_APP_API_URL}/api/v1/health/get-plan-premiums/unified-domestic-worker `, {
        method: 'POST',
        body: JSON.stringify({ ...data, source_id }),
        headers: { 'Content-Type': 'application/json' },
      });
      return val;
    } catch (error) {
      console.error('Error in getAffrodablePlans:', error);
      throw error;
    }
  };
};

export const getQuoteUnified  = (data) => {
    
  return async (dispatch) => {
    try {
      const val = await apiFetch(dispatch, `${process.env.REACT_APP_API_URL}/api/v1/health/get-quotation/unified-domestic-worker `, {
        method: 'POST',
        body: JSON.stringify({ ...data, source_id }),
        headers: { 'Content-Type': 'application/json' },
      });
      return val;
    } catch (error) {
      console.error('Error in getQuote:', error);
      throw error;
    }
  };
};

export const addPolicyUnified = (data) => {
  return async (dispatch) => {
    try {
      const val = await apiFetch(dispatch, `${process.env.REACT_APP_API_URL}/api/v1/health/add-policy/unified-domestic-worker`, {
        method: 'POST',
        body: JSON.stringify({ ...data, source_id }),
        headers: { 'Content-Type': 'application/json' },
      });
      return val;
    } catch (error) {
      console.error('Error in addPolicy:', error);
      throw error;
    }
  };
};